var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _g, _rect, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeams = function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#teams_svg__a)",
    d: "M19 13.903c0-.499.404-.903.903-.903h11.194c.499 0 .903.404.903.903V20.5a6.5 6.5 0 1 1-13 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#teams_svg__b)",
    d: "M9 12.226C9 11.549 9.549 11 10.226 11h13.548c.677 0 1.226.549 1.226 1.226V22a8 8 0 1 1-16 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 8,
    r: 3,
    fill: "#34439E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 8,
    r: 3,
    fill: "url(#teams_svg__c)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 4,
    fill: "url(#teams_svg__d)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "teams_svg__g",
    width: 16,
    height: 30,
    x: 9,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#teams_svg__e)",
    d: "M17 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#teams_svg__f)",
    d: "M10.226 11C9.549 11 9 11.549 9 12.226V22a8 8 0 1 0 16 0v-9.774c0-.677-.549-1.226-1.226-1.226z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#teams_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M7 12a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    y: 7,
    fill: "url(#teams_svg__h)",
    rx: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 11H5v1.835h2.995V21h2.01v-8.165H13z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__a",
    x1: 19,
    x2: 32.159,
    y1: 13.737,
    y2: 22.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__b",
    x1: 9,
    x2: 25,
    y1: 19.404,
    y2: 19.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7084EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__c",
    x1: 24,
    x2: 29.796,
    y1: 5.316,
    y2: 9.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__d",
    x1: 15.143,
    x2: 20.286,
    y1: 3.143,
    y2: 9.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__e",
    x1: 13.429,
    x2: 19.857,
    y1: 1.429,
    y2: 8.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__f",
    x1: 13.429,
    x2: 19.857,
    y1: 1.429,
    y2: 8.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams_svg__h",
    x1: 0,
    x2: 18,
    y1: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C56B9"
  })))));
};
export default SvgTeams;